import * as React from "react";
import { } from "../common/OneSignal";
import t from "../i18n";

declare type NotificationState = {
    subscribeToNotificationText: string;
    hasSubscribed: boolean;
    showSubscriptionButton: boolean;
}

export default class NotificationSubscriptionComp extends React.Component<any, NotificationState> {
    readonly state: NotificationState = {
        subscribeToNotificationText: t.common("notification-subscribe-button"),
        showSubscriptionButton: false,
        hasSubscribed: false
    };
    onManageWebPushSubscriptionButtonClicked = () => {
        let OneSignal = window.OneSignal;
        if (!OneSignal) return;
        this.getSubscriptionState().then(function (status) {
            if (status.isPushEnabled) {
                /* Subscribed, opt them out */
                OneSignal.setSubscription(false);
            } else {
                if (status.isOptedOut) {
                    /* Opted out, opt them back in */
                    OneSignal.setSubscription(true);
                } else {
                    /* Unsubscribed, subscribe them */
                    OneSignal.registerForPushNotifications();
                }
            }
        });
    }
    updateMangeWebPushSubscriptionButton = () => {
        const subscribeText = t.common("notification-subscribe-button");
        const unsubscribeText = t.common("notification-unsubscribe-button");
        const _this = this;
        this.getSubscriptionState().then(function (status) {
            const buttonText = !status.isPushEnabled || status.isOptedOut ? subscribeText : unsubscribeText;
            if (buttonText !== _this.state.subscribeToNotificationText) {
                _this.setState({ hasSubscribed: true });
            }
        });
    }
    getSubscriptionState = async () => {
        let OneSignal = window.OneSignal;
        if (!OneSignal) {
            return {
                isPushEnabled: false,
                isOptedOut: true
            };
        }
        return await Promise.all([
            OneSignal.isPushNotificationsEnabled(),
            OneSignal.isOptedOut()
        ]).then(function (result) {
            const isPushEnabled = result[0];
            const isOptedOut = result[1];
            return {
                isPushEnabled: isPushEnabled,
                isOptedOut: isOptedOut
            };
        });
    }
    async componentDidMount() {
        //TODO: check the login state and hide subscription for Guests
        const status = await this.getSubscriptionState();
        if (!status.isPushEnabled || status.isOptedOut)
            this.setState({ showSubscriptionButton: true });
    }
    render() {
        let OneSignal = window.OneSignal;
        if (!OneSignal) return <div></div>;
        const _this = this;

        // do not render if already subscribed
        // this.getSubscriptionState().then(function (status) {
        //     if (_this.state.showSubscriptionButton === false && (!status.isPushEnabled || status.isOptedOut)) {
        //         _this.setState( {showSubscriptionButton : true});
        //     }
        // });
        if (this.state.showSubscriptionButton === true) {
            /* This assumes you've already initialized OneSignal */
            OneSignal.push(function () {
                // If we're on an unsupported browser, do nothing
                if (!OneSignal.isPushNotificationsSupported()) {
                    return;
                }
                _this.updateMangeWebPushSubscriptionButton();
                OneSignal.on("subscriptionChange", function (isSubscribed: any) {
                    /* If the user's subscription state changes during the page's session, update the button text */
                    _this.updateMangeWebPushSubscriptionButton();
                });
            });
            if (this.state.hasSubscribed === true) {
                return (<div className="form-group">
                    <a
                        href="javascript:void(0)"
                        className='btn-subscribe'
                        id='my-notification-button' style={{ cursor: 'default' }}>
                        <i className="fa fa-bell-o" style={{ fontSize: 20, paddingRight: 5, }} />{this.state.subscribeToNotificationText}
                    </a>
                    <p className='txt-subscribe'>{t.common("notification-text")}</p>
                </div>);
            }
            else {
                return (<div className="form-group">
                    <a
                        href="javascript:void(0)"
                        onClick={_this.onManageWebPushSubscriptionButtonClicked}
                        className='btn-subscribe'
                        id='my-notification-button'>
                        <i className="fa fa-bell-o" style={{ fontSize: 20, paddingRight: 5, }} />{this.state.subscribeToNotificationText}
                    </a>
                    <p className='txt-subscribe'>{t.common("notification-text")}</p>
                </div>);
            }
        }
        else {
            return <div></div>;
        }
    }
}